import { setSourceAccount } from "../util/operations.js";
import { Operation, OperationBody } from "../../xdr/index.js";
import { InflationOpts, OperationAttributes } from "./types.js";

/**
 * This operation generates the inflation.
 * @param opts - Options object
 *   - `source`: The optional source account.
 */
export function inflation(opts: InflationOpts = {}): Operation {
  const opAttributes: OperationAttributes = {
    sourceAccount: null,
    body: OperationBody.inflation(),
  };
  setSourceAccount(opAttributes, opts);
  return new Operation(opAttributes);
}
